module.exports = __webpack_public_path__ + "media/footer/twitter-6c646675.svg";